<div class="page-header">
  <div class="page-header__content">
    <button
      *ngIf="showGoBackBtn"
      (click)="navigateBack()"
      mat-icon-button
      class="page-header__back-btn"
    >
      <mat-icon>arrow_back_ios</mat-icon>
    </button>

    <div class="page-header__title">
      <h1>{{ title | transloco }}</h1>
      <p *ngIf="subtitle">{{ subtitle | transloco }}</p>
    </div>
  </div>

  <div *ngIf="showActionBtn" class="page-header__action">
    <app-button
      [text]="btnText | transloco"
      [routerLink]="btnLink"
      [disabled]="disabled"
      [matTooltip]="tooltipText"
    ></app-button>
  </div>
</div>
